import { render, staticRenderFns } from "./PrintingPages.vue?vue&type=template&id=2745db29&scoped=true"
import script from "./PrintingPages.vue?vue&type=script&lang=js"
export * from "./PrintingPages.vue?vue&type=script&lang=js"
import style0 from "./PrintingPages.vue?vue&type=style&index=0&id=2745db29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745db29",
  null
  
)

export default component.exports